export default {
  signIn: 'Entrar',
  signOut: 'Sair',
  points: 'pontos',
  hyattSignInButton: 'Entrar no World of Hyatt',
};
